import type { CancelReason } from '~/domain/Assegurou/cancelAssurantService';
import type { CancelReasonDTO } from '~/dto/Assegurou/cancelAssurantService';

export const cancelReasonDTOtoCancelReason = (
  reasonDTO: CancelReasonDTO
): CancelReason => ({
  code: reasonDTO.codigo,
  description: reasonDTO.descricao,
  detailedDescription: reasonDTO.descricaoCompleta,
});
